module.exports = __webpack_public_path__ + "static/img/banner.e08fe9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site-image/banner.jpg
// module id = GO87
// module chunks = 169